import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function SubscriptionFaild() {
    const navigator = useNavigate();
    return <div className="page404">
        Something
        went Wrong
        <button className="btn btn-primary" onClick={() => navigator('/user/settings')}>Try Again</button>
    </div>;
}
